<template>
<div class="acomodar">
    <SegDatosSolicitud/>
</div>
</template>

<script>
import SegDatosSolicitud from '@/components/ModSeleccion/Seguimiento/SegDatosSolicitud.vue';
export default {
  name: 'SeguimientodeSolicitud',
  components: {
    SegDatosSolicitud
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style  scoped>

</style>